// extracted by mini-css-extract-plugin
export default {"overlayContainer":"styles_overlayContainer__Bubzn","backdrop":"styles_backdrop__BH+vi"};